import { JSX } from "react";
import { HipTasksOverviewWrapper } from "./HipTasks/HipTasksOverviewWrapper";
import { ImportedPlansOverviewWrapper } from "./ImportedPlans/ImportedPlansOverviewWrapper";
import { useConfig } from "@shared/common/contexts/config/useConfig";
import { MpsLoading } from "./MpsLoading/MpsLoading";

interface PlanOverviewProps {
  readonly loadData: boolean;
  readonly onCloseDialog: () => void;
  readonly onOpenImport: () => void;
}

export function PlanOverview({
  loadData,
  onCloseDialog,
  onOpenImport,
}: PlanOverviewProps): JSX.Element {
  const config = useConfig();

  return (
    <>
      {/* Replace with tractie-section-header when available */}
      <div slot="start" className="flex">
        <h4 className="m-0">Plannen</h4>
      </div>
      <div className="relative min-h-100">
        <tractie-tabs>
          <tractie-tab slot="tab">Oplossingen</tractie-tab>
          <div slot="panel">
            <HipTasksOverviewWrapper loadData={loadData} closeDialog={onCloseDialog} />
          </div>
          {config.personeel.enabled && (
            <>
              <tractie-tab slot="tab">Geïmporteerd</tractie-tab>
              <div slot="panel">
                <ImportedPlansOverviewWrapper loadData={loadData} closeDialog={onCloseDialog} />
              </div>
            </>
          )}
          {config.featureFlags.isMpsImportEnabled && (
            <>
              <tractie-tab slot="tab">Materieel Planning Service</tractie-tab>
              <div slot="panel">
                <MpsLoading closeDialog={onCloseDialog} />
              </div>
            </>
          )}
        </tractie-tabs>
        <div className="absolute top-0 right-0 z-1">
          <tractie-button
            data-testid="plan-overview-import-button"
            level="secondary"
            onClick={onOpenImport}
          >
            Plan importeren (Donna)
          </tractie-button>
        </div>
      </div>
    </>
  );
}
